<template>
    <div class="topbar-container">
        <div class="scrollbar-container">
            <div class="line"></div>
            <div class="bankList-list">
                <div
                    v-for="(item,i) in bankTypeData"
                    :key="i"
                    class="bankList-list-item border-bottom"
                >
                    <div class="item bh bstart">
                        <div
                            class="bg-contain ico"
                            :style="{backgroundImage: `url('${item.bankIcon}')`}"
                        ></div>
                        <div class="b1 c_black fz_34">{{item.bankName}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { user } from "@/mixin/user";
export default {
    mixins: [user],
    name: "CardBankList",
    computed: {
        // 获取银行卡列表
        bankTypeData() {
            return this.$store.getters["money/bankTypeData"];
        }
    },
    methods: {
        userLoginend() {
            this.$store.dispatch("money/bankTypeData");
        }
    }
};
</script>

<style scoped lang="scss">
@include ico-list("~@/assets/imges/ico/", "select");
.scrollbar-container {
    background-color: #f1f2f3;
}
.bankList-list-item {
    background-color: #fff;
    padding: 51px 46px;
    border-bottom: 1px solid #f1f2f3;
    .ico {
        width: 55px;
        height: 55px;
        margin-right: 20px;
    }
}
</style>

